module.exports = __webpack_public_path__ + "img/payment.3e110afd.svg";